// extracted by mini-css-extract-plugin
export default {"expandIcon":"expandIcon-T2SHo","toggled":"toggled-OvL2A"};